export default __webpack_public_path__ + "static/media/gadgets.fb3f3d1f.png";